import { EmailLoginType, emailServerConnectionType } from '@/containers/pages/filials/edit/utiils';
import { Nullable } from 'vitest';

export enum EmailServerIntegrationType {
  None = 0,
  Ssh = 1,
  Api = 2
}

interface Smtp {
  emailId: number;
}

export interface EmailServerServiceCheckIntegrationParams {
  ssh: Nullable<Ssh>;
  api: Nullable<SshApi>;
  smtp: Nullable<Smtp>;
  type: EmailServerIntegrationType;
}

export interface EmailServerGetParams {
  customerId: number;
}

export interface IMailServerIntegration {
  Ssh: Nullable<Ssh>;
  Api: Nullable<SshApi>;
  Smtp: Nullable<Smtp>;
  Type: EmailServerIntegrationType;
}

interface SshApi {
  Login: string;
  Password: string;
  Host: string;
  HasLdapAuth: boolean;
}

export interface Ssh {
  Server: string;
  User: string;
  Port: number;
  PrivateKeyBase64: string;
  HasKey: boolean;
}

export interface IMailServer {
  Integration: IMailServerIntegration;
  ImapServer: string;
  ImapPort: Nullable<number>;
  SmtpServer: string;
  SmtpPort: Nullable<number>;
  PopServer: string;
  PopPort: Nullable<number>;
  PopConnectionType: emailServerConnectionType;
  SmtpConnectionType: emailServerConnectionType;
  ImapConnectionType: emailServerConnectionType;
  CustomerId: number;
  Json: Nullable<string>;
  Name: string;
  Domains: string;
  Id?: number;
  useSsH: boolean;
  SmtpLoginType: EmailLoginType;
  ImapLoginType: EmailLoginType;
}

export const TEMPLATE_SSH = {
  User: '',
  Port: 0,
  PrivateKeyBase64: '',
  Server: '',
  HasKey: false
};

export const TEMPLATE_SMTP = {
  emailId: 0
};

export const TEMPLATE_API = {
  Login: '',
  Password: '',
  Host: '',
  HasLdapAuth: false
};

export const TEMPLATE_MAIL_SERVER_ENTITY: IMailServer = {
  Integration: {
    Ssh: null,
    Api: null,
    Smtp: null,
    Type: EmailServerIntegrationType.None
  },
  ImapServer: '',
  ImapPort: 0,
  SmtpServer: '',
  SmtpPort: 0,
  PopServer: '',
  PopPort: 0,
  PopConnectionType: 1,
  SmtpConnectionType: 1,
  ImapConnectionType: 1,
  CustomerId: 0,
  Json: null,
  Name: '',
  Domains: '',
  useSsH: false,
  SmtpLoginType: 0,
  ImapLoginType: 0
};

export const TEMPLATE_MAIL_SERVER = {
  TEMPLATE_MAIL_SERVER_ENTITY,
  TEMPLATE_API,
  TEMPLATE_SMTP,
  TEMPLATE_SSH
};
